import { render } from "./CheckoutIndex.vue?vue&type=template&id=1c1a209e"
import script from "./CheckoutIndex.vue?vue&type=script&lang=js"
export * from "./CheckoutIndex.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front-twint-ux/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__